const ArrowSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M11.3459 6.15296C11.2472 6.05502 11.1134 6 10.9739 6C10.8343 6 10.7005 6.05502 10.6018 6.15296L7.99682 8.73897L5.39185 6.15296C5.2926 6.0578 5.15967 6.00514 5.02168 6.00633C4.8837 6.00752 4.75171 6.06246 4.65414 6.15932C4.55656 6.25619 4.50122 6.38722 4.50002 6.5242C4.49882 6.66117 4.55186 6.79314 4.64773 6.89167L7.62476 9.84704C7.72345 9.94498 7.85728 10 7.99682 10C8.13637 10 8.2702 9.94498 8.36889 9.84704L11.3459 6.89167C11.4446 6.7937 11.5 6.66084 11.5 6.52232C11.5 6.38379 11.4446 6.25093 11.3459 6.15296Z"
        fill="#D5D5D5"
      />
    </svg>
  );
};

export default ArrowSvg;
